import { copy } from "../content/copy";

export default function Footer() {
  return (
    <footer className="border-t border-cream/10 py-12 px-6 text-center text-sm text-cream/50">
      <div className="max-w-3xl mx-auto space-y-4">
        <div className="font-display text-3xl text-cream">{copy.footer.wordmark}</div>
        <div>{copy.footer.tagline}</div>
        {copy.footer.note && (
          <div className="label-caps text-cream/40">{copy.footer.note}</div>
        )}
        <div className="flex justify-center gap-6 text-cream/70">
          <a href="#how" className="hover:text-coral transition-colors">How it works</a>
          <a href="#submit" className="hover:text-coral transition-colors">Leave one</a>
        </div>
        <div className="text-xs text-cream/30">© {new Date().getFullYear()} {copy.footer.copyright}</div>
      </div>
    </footer>
  );
}
